import React, { SVGProps } from 'react';

const CollapseExpandIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 12 12"
			fill="none"
			{...props}
		>
			<rect width="1" height="100%" fill="currentColor" />
			<path
				d="M12 5.5H5.915L8.71 2.705L8 2L4 6L8 10L8.705 9.295L5.915 6.5H12V5.5Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default CollapseExpandIcon;
